import React from "react";
import { Row, Label, Button, ButtonGroup, Col } from "reactstrap";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import './AlignmentButtonGroup.css'

export const AlignmentButtonGroup = ({ onChange, alignment, path }) => {
  return (
    <Row>
      <Col className="list-setting-item-title">
        <Label>
          <SystemLabel name="ItemPlacement" />
        </Label>
      </Col>
      <Col>
        <ButtonGroup className="alignment-button-group">
          <Button
            className={alignment === "left" ? "selected" : ""}
            onClick={e => onChange(null, "left", path)}
          >
            <i className="fa fa-align-left" />
          </Button>
          <Button
            className={alignment === "center" ? "selected" : ""}
            onClick={e => onChange(null,"center", path)}
          >
            <i className="fa fa-align-center" />
          </Button>
          <Button
            className={alignment === "right" ? "selected" : ""}
            onClick={e => onChange(null, "right", path)}
          >
            <i className="fa fa-align-right" />
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  );
};
